import PropTypes from "prop-types";
import React from "react";
import HubMonitoringList from "./HubMonitoringList";

export default function HubMonitoring({ programId }) {
  return <HubMonitoringList programId={programId} />;
}

HubMonitoring.propTypes = {
  programId: PropTypes.string.isRequired,
};
